import { useCallback } from "react";
import { DrawingCanvas } from "../components/editor/DrawingCanvas";
import { Btn } from "../components/UI/Btn";
import style from '../components/UI/Layout.module.css';
import { useStrokeContext } from "../services/editor/editorContext";
import { useRouterContext } from "../services/router/routerContext";

/** Toto je klíčová stránka pro kreslení obrázku. Měla by být dostupná pouze pokud uživatel smí kreslit. */
export const Editor: React.FC = () => {

    const { finished, clear } = useStrokeContext();

    const { showColor } = useRouterContext();

    const nextHandler = useCallback( () => {

        if ( finished ) {
            showColor();
        }

    }, [ finished, showColor ] );


    const clearHandler = useCallback( () => {

        if ( finished ) {
            clear();
        }

    }, [ finished, clear ] );


    return <>

        <div className={style.centeredMax}>
            <div className={style.inner}>
                <DrawingCanvas size={500} active={!finished} />
            </div>
        </div>


        {finished && <Btn 
            area="left" 
            onClick={clearHandler}
            square
            inverse
            icon="close"
        />}


        {finished && <Btn 
            area="right" 
            onClick={nextHandler}
            icon="right"
        >Další krok</Btn>}
    </>;
}